(function(angular) {
    'use strict';

    window.THF.Angular.JoinForm.factory('thfFieldDefinitionEligibility', function() {

        // // ELIBILITY_REMOVE
        // return {
        //     'readCriteria': {
        //         'label': '',
        //         'name': 'readCriteria',
        //         'defaultValue': '',
        //         'placeholder': '',
        //         'tooltip': 'Please read the ' + joinFormPageData.siteName + ' eligibility criteria to confirm that you are eligible to apply for a health insurance policy.',
        //         'options': [
        //             {
        //                 'label': 'I have read the ' + joinFormPageData.siteName + ' eligibility criteria and confirm that I am eligible to apply for a health insurance policy',
        //                 'value': 'Y'
        //             }
        //         ],
        //         'onChange': function (newValue, oldValue, tabModel, formModel) {
        //             if (newValue === 'Y') {
        //                 DSTAPI.track('event', {
        //                     category: 'Join Form - Eligibility',
        //                     action: 'Check Box Ticked',
        //                     label: 'Check Box Ticked'
        //                 });
        //             }
        //         },
        //         'validation': [
        //             'required',
        //             'requiredCheckbox'
        //         ]
        //     },
        //     'membershipNumber': {
        //         'label': 'Union Member Number (if applicable)',
        //         'labelStyle': '',
        //         'name': 'membershipNumber',
        //         'defaultValue': '',
        //         'placeholder': '',
        //         'tooltip': '',
        //         'onChange': function (newValue, oldValue, tabModel, formModel) {
        //             DSTAPI.track('event', {
        //                 category: 'Join Form - Eligibility',
        //                 action: 'Union Member Field Updated',
        //                 label: 'Union Member Field Updated'
        //             });
        //         },
        //         'validation': []
        //     }
        // };

        return {
            'readCriteria': {
                'label': 'readyCriteria',
                'name': 'readCriteria',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': 'Please read the ' + joinFormPageData.siteName + ' eligibility criteria to confirm that you are eligible to apply for a health insurance policy.',
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    //
                },
                'validation': [
                    'required',
                    'requiredCheckbox'
                ]
            },
            'currentMember': {
                'label': joinFormPageData.tabInfo.eligibility.fieldCurrentMemberLabel,
                'name': 'currentMember',
                'defaultValue': '',
                'placeholder': '',
                'options': [
                    {
                        'label': 'Yes',
                        'value': 'Y'
                    },
                    {
                        'label': 'No',
                        'value': 'N'
                    }
                ],
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    //
                },
                'validation': [
                    'required'
                ]
            },
            'union': {
                'label': 'Please select your union',
                'labelStyle': '',
                'name': 'union',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': joinFormPageData.unions,
                'validation': [
                    'required'
                ]
            },
            'formerMember': {
                'label': joinFormPageData.tabInfo.eligibility.fieldFormerMemberLabel,
                'name': 'formerMember',
                'defaultValue': '',
                'placeholder': '',
                'options': [
                    {
                        'label': 'Yes',
                        'value': 'Y'
                    },
                    {
                        'label': 'No',
                        'value': 'N'
                    }
                ],
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    //
                },
                'validation': [
                    'required'
                ]
            },
            'familyMember': {
                'label': joinFormPageData.tabInfo.eligibility.fieldFamilyMemberLabel,
                'name': 'familyMember',
                'defaultValue': '',
                'placeholder': '',
                'options': [
                    {
                        'label': 'Yes',
                        'value': 'Y'
                    },
                    {
                        'label': 'No',
                        'value': 'N'
                    }
                ],
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    //
                },
                'validation': [
                    'required'
                ]
            }
        };
    });
})(angular);
